import React from "react";
import { Card, CardHeader, CardTitle, CardContent } from "../ui/card";
import { Button } from "../ui/button";
import type { TFunction } from "i18next";

interface PersonalInfoCardProps {
  email: string;
  companyName: string;
  editingInfo: boolean;
  tempEmail: string;
  tempCompanyId: number | null;
  companies: any[];
  onEditClick: () => void;
  onSaveClick: () => void;
  setTempEmail: (email: string) => void;
  setTempCompanyId: (id: number) => void;
  t: TFunction<"translation", undefined>;
  compact?: boolean;
}

const PersonalInfoCard: React.FC<PersonalInfoCardProps> = ({
  email,
  companyName,
  editingInfo,
  tempEmail,
  tempCompanyId,
  companies,
  onEditClick,
  onSaveClick,
  setTempEmail,
  setTempCompanyId,
  t,
  compact = false,
}) => {
  return (
    <Card className={`border h-full flex flex-col ${compact ? 'shadow-sm' : ''}`}>
      <CardHeader className={compact ? "pb-2 pt-4 px-4" : "pb-2"}>
        <CardTitle className={compact ? "text-base" : "text-xl"}>{t("personal_information")}</CardTitle>
      </CardHeader>
      <CardContent className={`${compact ? 'text-xs px-4 pb-3' : 'text-sm sm:text-base md:text-lg'} text-[#4A5364] flex-1 flex flex-col`}>
        {editingInfo ? (
          <>
            <div className="flex-1">
              <input
                className={`w-full border rounded p-1 ${compact ? 'text-xs' : 'text-xs sm:text-sm'} bg-white`}
                type="email"
                value={tempEmail}
                onChange={(e) => setTempEmail(e.target.value)}
              />
              <select
                className={`w-full border rounded p-1 ${compact ? 'text-xs mt-1.5' : 'text-xs sm:text-sm mt-2'} bg-white`}
                value={tempCompanyId || ""}
                onChange={(e) => setTempCompanyId(Number(e.target.value))}
              >
                {companies.map((comp: any) => (
                  <option key={comp.id} value={comp.id}>
                    {comp.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="mt-auto">
              <div className={`h-px w-full bg-[#E4E4E7] ${compact ? 'my-2' : 'my-2 sm:my-4'}`} />
              <Button
                variant="link"
                className={`p-0 h-auto text-[#105BDB] ${compact ? 'text-xs' : ''}`}
                onClick={onSaveClick}
              >
                {t("save")}
              </Button>
            </div>
          </>
        ) : (
          <>
            <div className="flex-1">
              <p className={compact ? 'mb-1' : ''}>{email}</p>
              <p className={compact ? 'mt-1' : 'mt-2'}>{companyName}</p>
            </div>
            <div className="mt-auto">
              <div className={`h-px w-full bg-[#E4E4E7] ${compact ? 'my-2' : 'my-2 sm:my-4'}`} />
              <Button
                variant="link"
                className={`p-0 h-auto text-[#105BDB] ${compact ? 'text-xs' : ''}`}
                onClick={onEditClick}
              >
                {t("edit")}
              </Button>
            </div>
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default PersonalInfoCard;
